<h2 class="modal-header">{{ modalTitle | uppercase }}</h2>

  <ion-item lines="none" class="modal-item">
    <div class="modal-div" [innerHtml]="modalElements"></div>
  </ion-item>

  <ion-buttons class="modal-buttons">
    <ion-button class="modal-button" (click)="dismiss()">{{ modalDismiss }}</ion-button>
  </ion-buttons>